import { createContext, useContext } from 'react';

export type TutorialContextValues = {
  present: () => void;
  dismiss: () => void;
  cardVisible: boolean;
  completed: boolean;
  hideCard: () => void;
  markCompleted: () => void;
};

const defaultContextValues: TutorialContextValues = {
  present: () => {},
  dismiss: () => {},
  cardVisible: true,
  completed: false,
  hideCard: () => {},
  markCompleted: () => {}
};

export const TutorialContext =
  createContext<TutorialContextValues>(defaultContextValues);
export const useTutorial = () => useContext(TutorialContext);
